import * as SelectPrimitive from '@radix-ui/react-select';
import type { ForwardedRef } from 'react';
import styled from 'styled-components';

const elements = {
	label: styled(SelectPrimitive.Label)`
		padding: 0 25px;
		font-size: 12px;
		line-height: 25px;
		color: red;
	`,
};

export interface InputSelectGroupProps extends SelectPrimitive.SelectGroupProps {
	label: string;
}

export function CellulaInputSelectGroup(props: InputSelectGroupProps, ref: ForwardedRef<HTMLDivElement>): JSX.Element {
	return (
		<SelectPrimitive.Group {...props} ref={ref}>
			{/** biome-ignore lint/a11y/noLabelWithoutControl: suppressed due to migration - should be fixed */}
			<elements.label>{props.label}</elements.label>
			{props.children}
		</SelectPrimitive.Group>
	);
}
